import React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "../../components/Modal";

export const WxModal = (props) => {
  const { t } = useTranslation();
  return (
    <Modal className="wx-login-modal" {...{ visible: props.visible }}>
      <i onClick={() => props.setVisible(false)} className="icon authing-icon authing-guanbi" />
      <h2 className="wx-modal-title">{t("developer.wxLogin")}</h2>
      <div className="wx-modal-body">
        <div className="wx-qrcode-wrapper">
          <img
            className="wx-qrcode"
            alt="Wechat login qrcode"
            src="//files.authing.co/authing-website/sample-wx-qrcode.jpg"
          />
        </div>
      </div>
    </Modal>
  );
};
